import { createContext, useContext, useState, useMemo } from "react";
import PropTypes from "prop-types";

const SelectedValueContext = createContext(null);

export const SelectedValueProvider = ({ children }) => {
	const [selectedValue, setSelectedValue] = useState(null);
	const [selectedActionTypeValue, setSelectedActionTypeValue] = useState(null);
	const [initiatedBySelection, setInitiatedBySelection] = useState(null);
	const [checkedActions, setCheckedActions] = useState(null);
	const [checkedActivities, setCheckedActivities] = useState(null);
	const [selectedOptionNames, setSelectedOptionNames] = useState(null);
	const [allActionTypes, setAllActionTypes] = useState(null);
	const [updateSectionTypes, setUpdateSectionTypes] = useState(null);
	const [allActivities, setAllActivities] = useState(null);
	const [activityStatusError, setActivityStatusError] = useState(null);
	const [actionStatusError, setActionStatusError] = useState(null);
	const [fromDate, setFromDate] = useState(null);
	const [toDate, setToDate] = useState(null);

	const value = useMemo(
		() => ({
			selectedValue,
			setSelectedValue,
			selectedActionTypeValue,
			setSelectedActionTypeValue,
			initiatedBySelection,
			setInitiatedBySelection,
			checkedActivities,
			setCheckedActivities,
			checkedActions,
			setCheckedActions,
			selectedOptionNames,
			setSelectedOptionNames,
			allActionTypes,
			setAllActionTypes,
			updateSectionTypes,
			setUpdateSectionTypes,
			allActivities,
			setAllActivities,
			activityStatusError,
			setActivityStatusError,
			actionStatusError,
			setActionStatusError,
			fromDate,
			setFromDate,
			toDate,
			setToDate,
		}),
		[
			selectedValue,
			selectedActionTypeValue,
			initiatedBySelection,
			checkedActivities,
			checkedActions,
			selectedOptionNames,
			allActionTypes,
			updateSectionTypes,
			allActivities,
			activityStatusError,
			actionStatusError,
			fromDate,
			toDate,
		]
	);

	return <SelectedValueContext.Provider value={value}>{children}</SelectedValueContext.Provider>;
};

export const useSelectedValue = () => {
	const context = useContext(SelectedValueContext);
	if (!context) {
		throw new Error("useSelectedValue must be used within a SelectedValueProvider");
	}
	return context;
};

SelectedValueProvider.propTypes = {
	children: PropTypes.node.isRequired,
};
